const UNKNOWN = 'N/A';

const SHORTEN_NUMBER_CONFIG = {
    1_000: 'K',
    1_000_000: 'M',
};

const DISPLAY_TYPE = {
    PERCENTAGE: 'percentage',
    CURRENCY: 'currency',
    NUMBER: 'number',
};

const getFixedNumber = (number, maximumFractionDigits = 2) =>
    new Intl.NumberFormat('en-US', { maximumFractionDigits }).format(number);

const formatBigNumber = (number, numberSize, suffix) => {
    return `${getFixedNumber(number / numberSize, 0)}${suffix}`;
};

const formattedMetricNumericValue = (metricValue, isFullNumber) => {
    if (!metricValue) return UNKNOWN;
    if (isFullNumber) return Intl.NumberFormat().format(metricValue);

    for (const scalingFactor of Object.keys(SHORTEN_NUMBER_CONFIG)
        .sort()
        .reverse()) {
        const symbol = SHORTEN_NUMBER_CONFIG[scalingFactor];
        if (metricValue >= scalingFactor) return formatBigNumber(metricValue, scalingFactor, symbol);
    }

    return getFixedNumber(metricValue);
};

const formattedPercentageValue = (metricValue, isFullNumber) => {
    if (!metricValue) return UNKNOWN;
    const percentageValue = metricValue * 100;
    return `${isFullNumber ? percentageValue : getFixedNumber(percentageValue)}%`;
};

export const getFormattingFunction = displayFormat => {
    const { type, symbol = '' } = displayFormat;

    let formatMethod;

    switch (type) {
        case DISPLAY_TYPE.PERCENTAGE:
            formatMethod = formattedPercentageValue;
            break;
        case DISPLAY_TYPE.CURRENCY:
            formatMethod = formattedMetricNumericValue;
            break;
        case DISPLAY_TYPE.NUMBER:
            formatMethod = formattedMetricNumericValue;
            break;
        default:
            formatMethod = formattedMetricNumericValue;
    }

    return [formatMethod, symbol];
};

export const formatSymbol = (value, symbol) => {
    if (!symbol || value === UNKNOWN) return value;

    return `${symbol} ${value}`;
};
